import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/ViewTab.css';
import './classes/EditSortflag.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import EditSortflag from './EditSortflag';
import { Helmet } from 'react-helmet';

const ViewSortflag = () =>{
    const [isLoading, setIsLoading] = useState(true);

 
    const [toggle, setToggle] = useState(2);
     const [errors, setErrors] = useState({});
      const[success,setSuccess] = useState('');
    const[detailedview,setSortflagDetailedView] = useState({});
      const location  = useLocation();
      const drupal_uid = localStorage.getItem('drupal_uid');
      const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
       var loggedin_domain = drupal_domain_url;
      if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
      } 
      var {tid} = useParams();
     
     
      const {tab} = useParams();
      
      const loggedin_uid = localStorage.getItem('uid');
      const navigate = useNavigate();

        const app_url = configData.APP_URL;
      
        const domain_url = configData.DOMAIN_URL;

    function updateToggle(id){
        setToggle(id);
    
        if(id == 1) { 
        
       navigate("/taxonomy/term/"+tid+"/view");
        }
        if(id == 2) { 
         navigate("/taxonomy/term/"+tid+"/edit");
        }
     
    }

    useEffect(() => {
    Promise.all([
      retrieveSortflagDetails()
    ]).then(() => {
     
      setIsLoading(false);
      setToggle(1);
        
          if(tab == "view") {
            setToggle(1);
    
         }
         else if(tab == "edit") {
            setToggle(2);

          }
     });
    
    
  },[]);

  async function retrieveSortflagDetails() {
    
   
    const response = await fetch(
      app_url+'sortflag/getsortflagdetailedview?tid='+tid,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagDetailedView(responsedata.data.result);
    }
 
  }

    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
          <Helmet><title>{detailedview.name} | SMWW</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
                                      {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
                    {success && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                        </div>
                        )}
                   
                <>
                      <ul className="tabs primarya">
                        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View<span class="element-invisible">(active tab)</span></a></li>
                     <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>
                    
                      </ul></>
                       <div  className= {toggle === 1? "show-content" : "content"}>
                        {detailedview.name ? (<>Name: {detailedview.name} <br/></> ) : (
                            <></>
                        )
                        }
                         {detailedview.field_sortflag_archive_value ? (<>Archive: Yes </> ) : (
                            <>Archive: No </>
                        )
                        }
                        </div>
                        <div  className= {toggle === 2? "show-content" : "content"}>
                             <EditSortflag tid={tid} detailedview={detailedview} />
                        </div>
                     
            </div>
            <div className="right">
                <SalespersonSidebar/>
            </div>
        </div>
            )}
            </>
    );
};
export default ViewSortflag;